import "./EditorSidebar.css";

import {
    FaFont,
    FaDatabase,
    FaImage,
    FaSignature,
    FaQrcode,
    FaMinus,
    FaSquare,
    FaCircle,
    FaCheck,
    FaArrowDown,
    FaArrowUp,
    FaEye,
    FaEyeSlash,
    FaTimes
} from "react-icons/fa";


const COMPONENTS = [

    {
        type: "text",
        label: "Texto",
        icon: FaFont
    },

    {
        type: "dynamic",
        label: "Campo dinámico",
        icon: FaDatabase
    },

    {
        type: "image",
        label: "Imagen",
        icon: FaImage
    },

    {
        type: "signature",
        label: "Firma",
        icon: FaSignature
    },

    {
        type: "qr",
        label: "Código QR",
        icon: FaQrcode
    },

    {
        type: "line",
        label: "Línea",
        icon: FaMinus
    },

    {
        type: "rectangle",
        label: "Rectángulo",
        icon: FaSquare
    },

    {
        type: "ellipse",
        label: "Elipse",
        icon: FaCircle
    },

    {
        type: "checkbox",
        label: "Casilla de verificación",
        icon: FaCheck
    }

];


function EditorSidebar({
    onAddElement,
    elements = [],
    selectedElement,
    onSelectElement,
    onMoveLayer,
    onToggleLayerVisibility,
    showComponents = true,
    componentsOpen = false,
    onCloseComponents,
    layersOpen = false,
    layersModal = false,
    onCloseLayers
}) {


    const handleDragStart = (event, type) => {

        event.dataTransfer.setData("componentType", type);

        event.dataTransfer.effectAllowed = "copy";

    };

    const getLayerLabel = element => {
        if (element.type === "text") return element.text || "Nuevo texto";
        if (element.type === "dynamic") return `{{${element.variable || "campo"}}}`;
        if (element.type === "checkbox") return element.text || "Casilla de verificación";
        return COMPONENTS.find(component => component.type === element.type)?.label || element.type;
    };


    return (
        <>
            {showComponents && (
            <aside
                className={`editor-sidebar${componentsOpen ? " editor-sidebar-panel-open" : ""}`}
                role={componentsOpen ? "dialog" : undefined}
                aria-modal={componentsOpen ? "true" : undefined}
                aria-labelledby="editor-components-title"
            >
            <div className="editor-sidebar-header">

                <h3 id="editor-components-title">
                    Componentes
                </h3>

                <p>
                    Arrastra o toca un elemento para agregarlo
                </p>
                <button
                    type="button"
                    className="editor-components-close"
                    aria-label="Cerrar componentes"
                    onClick={onCloseComponents}
                >
                    <FaTimes aria-hidden="true" />
                </button>

            </div>


            <div className="editor-components">


                {COMPONENTS.map(
                    component => {

                        const Icon = component.icon;

                        return (

                            <button key={component.type} type="button" className="editor-component" draggable

                                onDragStart={
                                    event =>
                                        handleDragStart(event, component.type)
                                }

                                onClick={() =>
                                    onAddElement(
                                        component.type
                                    )
                                }

                            >

                                <span className="component-icon">

                                    <Icon />

                                </span>


                                <span>

                                    {component.label}

                                </span>


                            </button>

                        );

                    }
                )}


            </div>

            </aside>
            )}
            {layersOpen && (
                <section
                    className="editor-layers-panel"
                    role="dialog"
                    aria-modal={layersModal}
                    aria-labelledby="editor-layers-title"
                >
                    <div className="editor-layers-heading">
                        <h2 id="editor-layers-title">Capas</h2>
                        <span>{elements.length}</span>
                        <button type="button" aria-label="Cerrar capas" onClick={onCloseLayers}>
                            <FaTimes aria-hidden="true" />
                        </button>
                    </div>
                    {elements.length === 0 ? (
                        <p className="editor-layers-empty">Aún no hay elementos</p>
                    ) : (
                        <ol className="editor-layers-list" aria-label="Elementos del certificado">
                            {[...elements].reverse().map((element, visualIndex) => {
                                const Component = COMPONENTS.find(component => component.type === element.type);
                                const Icon = Component?.icon || FaFont;
                                const label = getLayerLabel(element);
                                const layerIndex = elements.length - 1 - visualIndex;

                                return (
                                    <li
                                        className={`editor-layer ${selectedElement === element.id ? "editor-layer-selected" : ""} ${element.visible === false ? "editor-layer-hidden" : ""}`}
                                        key={element.id}
                                    >
                                        <button
                                            type="button"
                                            className="editor-layer-select"
                                            aria-pressed={selectedElement === element.id}
                                            onClick={() => onSelectElement(element.id)}
                                        >
                                            <Icon aria-hidden="true" />
                                            <span title={label}>{label}</span>
                                        </button>
                                        <div className="editor-layer-actions">
                                            <button
                                                type="button"
                                                aria-label={`Subir capa ${label}`}
                                                title="Traer al frente"
                                                disabled={layerIndex === elements.length - 1}
                                                onClick={() => {
                                                    onSelectElement(element.id);
                                                    onMoveLayer(element.id, "up");
                                                }}
                                            >
                                                <FaArrowUp />
                                            </button>
                                            <button
                                                type="button"
                                                aria-label={`Bajar capa ${label}`}
                                                title="Enviar atrás"
                                                disabled={layerIndex === 0}
                                                onClick={() => {
                                                    onSelectElement(element.id);
                                                    onMoveLayer(element.id, "down");
                                                }}
                                            >
                                                <FaArrowDown />
                                            </button>
                                            <button
                                                type="button"
                                                aria-label={`${element.visible === false ? "Mostrar" : "Ocultar"} capa ${label}`}
                                                title={element.visible === false ? "Mostrar" : "Ocultar"}
                                                aria-pressed={element.visible !== false}
                                                onClick={() => onToggleLayerVisibility(element.id)}
                                            >
                                                {element.visible === false ? <FaEyeSlash /> : <FaEye />}
                                            </button>
                                        </div>
                                    </li>
                                );
                            })}
                        </ol>
                    )}
                </section>
            )}
        </>
    );
}


export default EditorSidebar;
